export default Object.freeze({
  GoogleDrive: 1,
});
